import request from '@/utils/request'

export function getCouponList(data) {
  return request({ url: '/admin/coupon/list', method: 'post', data })
}

export function getCouponDetail(data) {
  return request({ url: '/admin/coupon/detail', method: 'post', data })
}

export function createCoupon(data) {
  return request({ url: '/admin/coupon/create', method: 'post', data })
}

export function updateCoupon(data) {
  return request({ url: '/admin/coupon/update', method: 'post', data })
}

export function issueCoupon(data) {
  return request({ url: '/admin/coupon/issue', method: 'post', data })
}

export function getCouponRecords(data) {
  return request({ url: '/admin/coupon/records', method: 'post', data })
}
